<template>
  <v-content id="main-content">
  <v-tabs background-color="#2665AC" v-model="page" dark slider-color="yellow" centered>
    <v-tab v-for="date in sortedDates" :key="date" ripple>
      {{displayDate(date)}}
    </v-tab>
    <v-tab-item v-for="date in sortedDates" :key="date">
      <v-list three-line>
        <v-list-item class="live-view" v-for="live in dateLives[date]" v-if="live.isFavoriteLive || !onlyFavoriteLive" :class="liveViewClass(live)" @click="selectLiver(live)">
          <v-list-item-content class="live-view-content">
            <v-list-item-title class="live-view-title-text subheading">{{dateToTitle(live.date)}}<img class="app-logo" :src="logoUrl(live.siteType)" alt=""></v-list-item-title>
            <v-list-item-subtitle class="live-view-subtitle-text title live-view-title">
              <v-btn height="42px" width="42px" v-for="liver in live.livers" text icon small class="img-btn" @click.stop="moveSite(live.siteType, liver)" :key="liver && liver.id">
                <v-img v-if="liver" height="42px" width="42px" :src="`https://wikiwiki.jp/nijisanji/?plugin=ref&page=${liver.name}&src=face.png`" contain></v-img>
              </v-btn>              
              {{live.title}}
              <v-btn height="42px" width="42px" text icon small class="img-btn" @click.stop="showLinkList(live)">
                <v-img height="42px" width="42px" src="/img/link_icon.png" contain></v-img>
              </v-btn>
              <v-btn text icon small class="img-btn" @click.stop="showTagList(live)">
                <v-img height="42px" width="42px" src="/img/twitter_logo.png" contain></v-img>
              </v-btn>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-tab-item>
  </v-tabs>
    <v-speed-dial v-model="fab" fixed bottom right>
      <template v-slot:activator>
        <v-btn v-model="fab" dark fab color="blue darken-2">
          <v-icon v-if="!fab">menu</v-icon>
          <v-icon v-else>close</v-icon>
        </v-btn>
      </template>
      <v-btn color="yellow" dark fab @click="onlyFavoriteLive  = !onlyFavoriteLive">
        <v-icon v-if="!onlyFavoriteLive" color="white lighten-1">star_border</v-icon>
        <v-icon v-else color="white">star</v-icon>           
      </v-btn>
      <v-btn color="blue" dark fab @click="reload">
        <v-icon>sync</v-icon>
      </v-btn>
      <v-btn color="red" dark fab @click="goTo('.on-air-live', option)">
        <v-icon>cast</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-dialog v-model="showSiteDialog">
      <v-card>
        <v-card-title primary-title>配信サイト</v-card-title>
        <v-list>
          <v-list-item v-for="liver in selectedLivers" @click="moveSite(selectedLive.siteType, liver)">
            <v-list-item-content>
              <v-list-item-title>{{liver.name}}</v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showTwitterDialog">
      <v-card>
        <v-card-title primary-title>ハッシュタグ</v-card-title>
        <v-list>
          <v-list-item v-for="tag in selectedTags" @click='open(`https://twitter.com/hashtag/${tag}?src=hash`)'>
            <v-list-item-content>
              <v-list-item-title>{{`#${tag}`}}</v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLinkDialog">
      <v-card>
        <v-card-title primary-title>リンク</v-card-title>
        <v-list>
          <v-list-item v-for="(url, name) in selectedLinks" @click="open(url)">
            <v-list-item-content>
              <v-list-item-title>{{name}}</v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-title color="white">
          loading...
        </v-card-title>
        <v-progress-linear indeterminate color="cyan"></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<style scoped>
  #main-content {
    padding-top: 0px !important;
    padding-left: 0px !important;
  }

  .double-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
    height: auto !important;
    padding: 0px !important;
  }

  .date-header {
    background-color: #e0e0e0 !important;
    color: rgba(0,0,0,.54);
    font-weight: bold;
  }

  .live-header {
    width: 100% !important;
    margin: 0px !important;
    padding: 8px 16px !important;
  }

  .live-today {
    background-color: #2665AC;
    color: #FFFFFF !important;
    font-weight: bold !important;
  }

  .live-view-title-text {
    color: #757575;
  }

  .live-view-subtitle-text {
    color: #000000;
  }

  .img-btn {
    margin: 8px 8px;
  }

  .live-view, .live-view-content {
    height: auto !important;
  }

  .live-view-title {
    height: auto !important;
  }

  .on-air-live {
    background-color: #ffebee;
  }

  .favorite-live {
    background-color: #FFFDE6;
  }

  .app-logo {
    vertical-align: middle;
    margin-left: 8px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
</style>

<style>
  .v-list--three-line .v-list__tile {
    height: auto !important;
    padding-top: 8px !important;
  }
</style>

<script>
import moment from 'moment';
import { logo } from '@/util/config.js';
import api from '@/util/api.js';
import ls from '@/util/local_storage.js';
import { clearInterval } from 'timers';

  export default {
    data: () => ({
      dateLives: {},
      moment: moment,
      showSiteDialog: false,
      showTwitterDialog: false,
      showLinkDialog: false,
      isLoading: false,
      isLoaded: false,
      selectedLive: null,
      selectedTags: [],
      selectedLinks: [],
      notificationIds: [],
      logo: logo,
      page: 0,
      onlyFavoriteLive: false,
      option: {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      },
      fab: false
    }),

    props: {
    },

    computed: {
      selectedLivers: function() {
        return this.selectedLive ? this.selectedLive.livers : []
      },
      selectedHashTags: function() {
        return this.selectedLive ?
          this.selectedLive.livers.map(l => l.tags).reduce((acc, t) => acc.concat(t),[]) :
          []
      },
      sortedDates: function() {
        return Object.keys(this.dateLives).sort((a,b) => moment(a).unix() - moment(b).unix());
      },
      livers: function() {
        return this.$store.state.livers;
      },
      favoriteLivers: function() {
        return this.$store.state.favoriteLivers;
      },
      notifyMinutes: function() {
        return this.$store.state.notifyMinutes;
      },
      canReload: function() {
        return this.$store.state.canReload;
      },
      reloadMinutes: function() {
        return this.$store.state.reloadMinutes;
      },
      reloadProcess: {
        get() {
          return this.$store.state.reloadProcess;
        },
        set(value) {
          this.$store.commit('setReloadProcess', value);
        }
      }
    },

    created() {
    },

    mounted() {
      initialize(this);
      if(this.isLoaded) {
        this.isLoaded = false;
        this.goTo('.on-air-live', this.option);
      }
      if(this.reloadProcess) {
        window.clearInterval(this.reloadProcess);
        this.reloadProcess = null;
      }
      if(this.canReload) {
        this.reloadProcess = window.setInterval(() => initialize(this), this.reloadMinutes * 60 * 1000);
      }
    },

    methods: {
      dateToTitle: v => v ? moment.unix(v.$date / 1000).format('HH時mm分') : "未定",
      displayDate: function(date) {
        if(isToday(date)) {
          return "今日";
        } else if(isTomorrow(date)) {
          return "明日";
        } else if (isYesterday(date)) {
          return "昨日";
        } else {
          return moment(date).format('M/D');
        }
      },
      logoUrl: function(v) {
        return `/img/${this.logo[v]}`;
      },
      selectLiver: function(live) {
        this.selectedLive = live;
        if(live.livers.length == 1) {
          moveSite(live.siteType, live.livers[0]);
        } else if(live.livers.length > 1) {
          this.showSiteDialog = true;
        }
      },
      showTagList: function(live) {
        this.selectedTags = live.livers.map(l => l.tags).reduce((acc, t) => acc.concat(t),[]);
        this.showTwitterDialog = true;
      },
      showLinkList: function(live) {
        this.selectedLinks = live.links;
        this.showLinkDialog = true;
      },
      clearNotification: function() {
        this.notificationIds.forEach(id => clearTimeout(id));
        this.notificationIds = [];
      },
      open: url => window.open(url, "_blank"),
      liveViewClass: function(live) {
        if(live.date == null) return { 'favorite-live': live.isFavoriteLive };
        let liveStart = moment.unix(live.date.$date / 1000);
        let liveEnd = moment.unix(live.date.$date / 1000).add(1, 'hours');
        let now = moment();
        let onAir = now.isBetween(liveStart, liveEnd);
        return {
          'on-air-live': onAir,
          'favorite-live': !onAir && live.isFavoriteLive
        };
      },
      reload: function() {
        initialize(this);
      },
      moveSite: moveSite,
      goTo: function(selector, option) {
        return this.$vuetify.goTo(selector, option);
      }
    }
  }

  const isToday = v => v ? moment(v).isSame(moment().startOf('day')) : false;
  const isTomorrow = v => v ? moment(v).isSame(moment().add(1, 'days').startOf('day')) : false;
  const isYesterday = v => v ? moment(v).isSame(moment().subtract(1, 'days').startOf('day')) : false;

  function initialize(self) {
    self.isLoading = true;
    api.get('/lives').then(res => {
      let dateLives = res.data;
      Object.keys(dateLives).forEach(key => {
        dateLives[key] = dateLives[key].map(live => {
          live.livers = live.livers.map(liver_id => self.livers.find(liver => liver.id == liver_id));
          live.isFavoriteLive = isFavoriteLive(live, self.favoriteLivers);
          return live;
        });
      });
      self.dateLives = dateLives;
      self.page = self.sortedDates.findIndex(isToday);
      self.isLoading = false;
      self.isLoaded = true;
      let todayKey = Object.keys(self.dateLives).find(isToday);
      if(todayKey) {
        let lives = self.dateLives[todayKey];
        self.clearNotification();
        self.notificationIds = registerNotification(lives, self.notifyMinutes);
      }
      setTimeout(() => self.goTo('.on-air-live', self.option), 1000);
    }).catch(e => {
      console.log(e);
      self.isLoading = false;
    })
  }

  function isFavoriteLive(live, favoriteLivers) {
    return live.livers.filter(liver => liver).reduce((acc, liver) => acc || !!favoriteLivers[liver.id], false);
  }

  function moveSite(siteType, liver) {
    let site = liver.sites.find(site => site.type == siteType);
    if(site) {
      window.open(site.liveUrl, '_blank');
    }
  }

  function registerNotification(lives, notifyMinutes) {
    return lives.filter(l => l.isFavoriteLive && l.date && moment.unix(l.date.$date / 1000).isAfter(moment()))
                .map(l => createNotification(l, notifyMinutes * 60000));
  }

  function createNotification(live, interval = 600000) {
    let nowTimeMillis = (new Date()).getTime();
    return setTimeout(() => {
      let n = new Notification(live.title, {
        body: "もうすぐ配信が始まります。",
        icon: 'images/app_icon.png'
      });
      if(live.livers.length > 0) {
        n.onclick = () => moveSite(live.siteType, live.livers[0]);
      }
      setTimeout(n.close.bind(n), 5000);
    }, live.date.$date - nowTimeMillis - interval);
  }
</script>
